import { useEffect } from 'react';
import { useReportes } from '../../../hooks/reportes/useReportes';
import { TabsReportes } from '../../components/tabs/TabsReportes';

export const Reportes = () => {

    const reportes = [
        {
            codigoReporte: 'RP001',
            nomReporte: 'Reporte de atención',
            tituloReporte: 'Reporte 001'
        },
        {
            codigoReporte: 'RP002',
            nomReporte: 'Resumen Ejecutivo Biix',
            tituloReporte: 'Reporte 002'
        },
        {
            codigoReporte: 'RP003',
            nomReporte: 'Reporte de Producción para Paradero y Horario',
            tituloReporte: 'Reporte 003'
        },
        {
            codigoReporte: 'RP004',
            nomReporte: 'Reporte de Gestión de recarga',
            tituloReporte: 'Reporte 004'
        },
    ]
    
    return(
        <div
            className="px-3 py-5 relative top-0 bottom-0 left-0 right-0 contenedor-tabla w-full h-full overflow-hidden"
        >
            <TabsReportes listaMenus={reportes}></TabsReportes>
        </div>
   ) 
}